export const EMPTY_MODAL_MESSAGE =
  'There are no entities on this loan that match the configured custom fields.';

export const SUBMIT_SUCCESS_MESSAGE = 'Custom field values were saved successfully.';
